import { zExt } from "@redotech/redo-model/common/zod-util";
import { z } from "zod/v4";

export enum DeleteGiftReceiptErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  NOT_FOUND = "NOT_FOUND",
  FAILED_TO_DELETE = "FAILED_TO_DELETE",
}

export const deleteGiftReceipt = {
  name: "deleteGiftReceipt" as const,
  input: z.object({ receiptId: zExt.objectId(), orderId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
